import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

export class API {

  static url = "https://phlebonurse.herokuapp.com";
  // static url = "http://localhost:5000";

  static async listCases(token) {
    try {
      const resp = await fetch(`${this.url}/api/cases/`, {
        method: 'GET',
        headers :{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }}
      )
      return await resp.json()
    }
    catch (error) {
      return console.log(error)
    }

  }

  static async registerNurse(data){
    try {
      const resp = await fetch(`${this.url}/api/nurses`, {
        method: 'POST',
        headers :{
          'Content-Type':'application/json',
        },
        body: JSON.stringify(data)
      })
      return await resp.json()
    }
    catch (error) {
      return console.log(error)
    }

  }

  static async retrieveNurse(id, token) {
    try {
      const resp = await fetch(`${this.url}/api/nurses/${id}`, {
        method: 'GET',
        headers :{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }}
      )
      return await resp.json()
    }
    catch (error) {
      return console.log(error)
    }

  }

  static async retrieveUser(token){
    try{
      const resp = await fetch(`${this.url}/api/nurses/retrieve_user/`, {
        method: 'GET',
        headers :{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }}
      )
      return await resp.json()
    }
    catch(error) {
      return console.log(error)
    }
    
    
  }

  static async uploadCases(file, token){
    console.log("Uploading cases...")
    try {
      const resp = await fetch(`${this.url}/api/cases/upload_cases/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`
        },
        body: file
      })
      return await resp.json()
    } catch (error) {
      return console.log(error)
    }
  }

  static async uploadReport(pk, file, date, status, feedback, message, token){

    const firebaseConfig = {
      storageBucket: 'phlebonurse.appspot.com'
    };
    
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    
    // Initialize Cloud Storage and get a reference to the service
    const storage = getStorage(app);

    // Create file metadata including the content type
    /** @type {any} */
    const metadata = {
      contentType: file.type,
    };
    
    // Upload the file and metadata
    const storageRef = ref(storage, `images/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on('state_changed',
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            //console.log('Upload is running');
            break;
        }
      }, 
      (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            alert("User doesn't have permission to access the object");
            break;
          case 'storage/canceled':
            alert("User canceled the upload");
            break;

          // ...

          case 'storage/unknown':
            alert("Unknown error occurred, inspect error.serverResponse");
            break;
        }
      }, 
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref)
        .then((downloadURL) => {
          fetch(`${this.url}/api/cases/${pk}/upload_report/`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token['pn-token']}`
              },
              body: JSON.stringify({'url': downloadURL,
                                    'date': date,
                                    'status':status,
                                    'feedback':feedback,
                                    'message':message
              })
          })
          .then(resp => resp.json())
          .catch(error => console.log(error))
        });
      }
    );
  }

  static async retrieveReport(token, pk){
    try {
      const resp = await fetch(`${this.url}/api/cases/${pk}/retrieve_report/`, {
        method: 'GET',
        headers: {
          'Authorization': `Token ${token}`
        }
      })
      return await resp.json()
    } catch (error) {
      return console.log(error)
    }
  }

  static async  loginUser(body, token) {
    try {
      const resp = await fetch(`${this.url}/auth/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        },
        body: JSON.stringify(body)
      })
      return await resp.json()
    } catch (error) {
      return console.log(error)
    }
  }

  static async  registerNurse(body) {
    try{
      const resp = await fetch(`${this.url}/api/nurses/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      })
      return await resp.json()
    }
    catch(error) {
      return console.log(error)
    }

    
  }

  static async getNurseList(token) {
    try{
      const resp = await fetch(`${this.url}/api/nurses/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        },
      })
      return await resp.json()
    }
    catch(error) {
      return console.log(error)
    }

    
  }

  static async updateCase(pk, data, token){
    try {
      const resp = await fetch(`${this.url}/api/cases/${pk}/`, {
        method: 'PUT',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      return await resp.json()
    } catch (error) {
      return console.log(error)
    }
  }

  static async checkUser(token, body){
    const resp = await fetch(`${this.url}/api/users/check_user/`, {
        method: 'POST',
        headers :{
          'Authorization': `Token ${token}`,
          'Content-Type':'application/json',
        },
        body: JSON.stringify(body)
    })
    return await resp.json()
  }

  static async checkInsurer(body){
    const resp = await fetch(`${this.url}/api/insurers/login/`, {
        method: 'POST',
        headers :{
          'Content-Type':'application/json',
        },
        body: JSON.stringify(body)
    })
    return await resp.json()
  }

  static async loginInsurer(name, token){
    console.log(name, token)
    const resp = await fetch(`${this.url}/api/insurers/loginList/`, {
      method: 'POST',
      headers :{
        'Content-Type':'application/json',
      },
      body: JSON.stringify({'insurer':name, 'token': token})
    })
    return await resp.json()
  }

}